import React from 'react'

import { Button } from '@mui/material'
import { useResendVerifyEmail } from 'features/customers/hooks/useResendVerifyEmail'

import { Badge } from 'components/_base'

type CustomerUserVerifiedProps = {
  userId: number
  verified: boolean
}

const CustomerUserVerified = ({ userId, verified }: CustomerUserVerifiedProps) => {
  const { mutateAsync: resendVerifyEmail } = useResendVerifyEmail()

  const onResendButtonClick = async () => resendVerifyEmail(userId)

  return (
    <div>
      <Badge
        color={verified ? 'green' : 'yellow'}
        sx={{ mr: '0.5rem' }}
        text={verified ? 'Verified' : 'Not verified'}
      />
      {!verified && <Button onClick={onResendButtonClick}>Resend</Button>}
    </div>
  )
}

export default CustomerUserVerified
